import BybPerformanceChip from "@Components/common/byb-ds/byb-performance-chip";
import BybVrCard from "@Components/common/byb-ds/cards/byb-vr-card";
import ProgressDialog from "@Components/game/progress/progress-dialog";
import { useProgress } from "@Context/game/progress/progress-context";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import useI18n from "@i18n";
import { Skeleton, Stack, Typography } from "@mui/material";
import FillingBrainIcon from "@Resources/app/icons-v2/system-icons/filling-brain-icon";
import { useState } from "react";

const ProgressBybIqCard = () => {
  const { i18n } = useI18n();
  const { currentBybIq, isCurrentBybIqLoading } = useProgress();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentMetricKey, setCurrentMetricKey] = useState(MetricFilterTypes.BYB_IQ);

  const handleOpenDialog = () => {
    setCurrentMetricKey(MetricFilterTypes.BYB_IQ);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  if (isCurrentBybIqLoading) {
    return (
      <BybVrCard>
        <Stack gap={2} alignItems="center">
          <Skeleton variant="circular" width={160} height={160} />
          <Stack spacing={0} alignItems="center">
            <Skeleton variant="text" width={120} height={60} />
            <Skeleton variant="text" width={100} height={30} />
          </Stack>
          <Skeleton variant="rounded" width={80} height={30} />
        </Stack>
      </BybVrCard>
    );
  }

  return (
    <>
      <BybVrCard onClick={handleOpenDialog}>
        <Stack spacing={2.5} alignItems="center" justifyContent="center" height="100%">
          <FillingBrainIcon size={175} fillPercentage={currentBybIq / 10.0} />
          <Stack gap={0.75} textAlign="center">
            <Typography variant="text3xl700" color="text.primary">
              {i18n("progress.byb_iq.score", { byb_iq: currentBybIq })}
            </Typography>
            <Typography variant="textLg400" color="text.secondary">
              {i18n("progress.byb_iq.last_5_sessions")}
            </Typography>
          </Stack>
          <BybPerformanceChip score={currentBybIq} />
        </Stack>
      </BybVrCard>

      <ProgressDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        currentMetricKey={currentMetricKey}
        onMetricChange={key => setCurrentMetricKey(key as MetricFilterTypes)}
      />
    </>
  );
};

export default ProgressBybIqCard;
